import { render, staticRenderFns } from "./BadgeStateFormatter.vue?vue&type=template&id=154124fa&"
import script from "./BadgeStateFormatter.vue?vue&type=script&lang=js&"
export * from "./BadgeStateFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports